import React, { createContext, useContext, ReactNode } from 'react';

interface Config {
  apiUrl: string;
  stripePublishableKey: string;
  landingPageUrl: string;
  cloudinaryUrl: string;
  cloudinaryMobileUrl: string;
}

const defaultConfig: Config = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://api.givingfortheliving.com/v1',
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',
  landingPageUrl: process.env.REACT_APP_LANDING_URL || 'https://givingfortheliving.com',
  cloudinaryUrl: process.env.REACT_APP_CLOUDINARY_URL || 'https://res.cloudinary.com/gftl/image/upload/v1/',
  cloudinaryMobileUrl: process.env.REACT_APP_CLOUDINARY_MOBILE_URL || 'https://res.cloudinary.com/gftl/image/upload/c_scale,w_150/v1/',
};

const ConfigContext = createContext<Config>(defaultConfig);

interface ConfigProviderProps {
  children: ReactNode;
}

export const ConfigProvider: React.FC<ConfigProviderProps> = ({ children }) => {
  return (
    <ConfigContext.Provider value={defaultConfig}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = (): Config => {
  return useContext(ConfigContext);
};

export default ConfigContext;
